import React, { createContext, useContext, useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { useAuth } from '../authContext';
import { initFirebase } from '../../firebase/firebase';
import { ACCESS_LEVELS } from '../../firebase/database';

const AdminContext = createContext({
  isAdmin: false,
  loading: true,
});

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdmin must be used within an AdminProvider');
  }
  return context;
};

export const AdminProvider = ({ children }) => {
  const { currentUser } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAdminStatus = async () => {
      if (!currentUser) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      try {
        const { db } = await initFirebase();
        const adminRef = doc(db, "AccessControl", currentUser.uid, "status", ACCESS_LEVELS.ADMIN);
        const adminDoc = await getDoc(adminRef);
        
        setIsAdmin(adminDoc.exists() && adminDoc.data().status === 'active');
      } catch (error) {
        console.error('Error checking admin status:', error);
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    };

    checkAdminStatus();
  }, [currentUser]);

  const value = {
    isAdmin,
    loading,
  };

  return (
    <AdminContext.Provider value={value}>
      {children}
    </AdminContext.Provider>
  );
};
